import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { ColorPicker } from './color-picker.comp';
import { getBaseReactDriver } from '../../common/base-driver';
import { createLegacyDeprecatedInputDriver } from '../../primitives/deprecated-input/input.legacy-driver';
export var createColorPickerDriver = function (elemOrLegacyBaseDriver) {
    var base = getBaseReactDriver(elemOrLegacyBaseDriver);
    var inputDriver = createLegacyDeprecatedInputDriver(base.elem);
    return {
        getDisplayedColor: function () { return inputDriver.getValue(); },
        enterColor: function (color) {
            inputDriver.enterValue(color);
            inputDriver.pressEnter();
            base.find('.apply-button').click();
        },
        isInputValid: function () { return inputDriver.isValid(); },
        getCancelButtonText: function () { return base.find('.cancel-button').getText(); },
        getApplyButtonText: function () { return base.find('.apply-button').getText(); },
        getErrorMsg: function () { return inputDriver.getValidationErrorMessage(); },
        base: base
    };
};
export var renderColorPickerAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(ColorPicker, __assign({}, props)));
    return createColorPickerDriver(elem);
};
//# sourceMappingURL=color-picker.driver.js.map